import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions';
import React, { useContext } from 'react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { gEnums } from '../../../../global/enums/globalEnums';
import SeasonMatchesProvider from '../../cnr/contexts/SeasonMatchesContext';
import SportsDataProvider from '../../cnr/contexts/SportsDataContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { LevelSchedule } from './LevelSchedule';
import { Scoreboard } from './Scoreboard';
import TeamSchedule from './TeamSchedule';

export const SportsSchedules = (props) => {

  const {
    forBackup,
    matchScheduleDisplayType,
    teamKey,
    fromSquares,
  } = props;

  let _matchScheduleDisplayType = matchScheduleDisplayType || gEnums.matchScheduleDisplayTypes.clickedDates
  let _useScrollRef = false

  switch (_matchScheduleDisplayType) {
    case gEnums.matchScheduleDisplayTypes.levelTabsFull:
      _useScrollRef = true;
    default:
    // nothing
  }

  // Contexts
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { paps_state } = states ?? {};

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};
  const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info;
  const { matches_groupInfo } = _matches_info ?? {};
  const { scheduleLevelKeys: _scheduleLevelKeys, levelSectionDateMatches: _levelSectionDateMatches } = matches_groupInfo ?? {};

  // Path views
  const { pathViews } = paps_state ?? {};

  const { _matchDisplayType } = useMatchScheduleOptions({ matchScheduleDisplayType })

  switch (_matchDisplayType) {
    case _matchDisplayTypes.scoreboard:
      return <Scoreboard />
    case _matchDisplayTypes.levelMatches:
      return <LevelSchedule />
    case _matchDisplayTypes.levelOverviewMatches:
    case _matchDisplayTypes.teamMatches:
      return <TeamSchedule
        matchScheduleDisplayType={matchScheduleDisplayType}
        teamKey={teamKey || pathViews.teams}
        fromSquares={fromSquares}
      />
    default:
      return <div>{_matchDisplayType}</div>
  }

};

/**
 * 
 * @param {object} props 
 * @returns the MatchSchedule componnent wrapped with SeasonMatchesProvider
 */
const SportsSchedulesProvider = React.memo((props) => {
  return <SportsDataProvider>
    <SeasonMatchesProvider  {...props}>
      <SportsSchedules {...props} />
    </SeasonMatchesProvider>
  </SportsDataProvider>
});

export default SportsSchedulesProvider